import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentIndexSong,
  setPlay,
  setRepeat,
} from "../../../store/features/audioSlice";
import { RootState } from "../../../store/store";
import scrollIntoView from "../../../utils/scrollElm";
import { Icons } from "../../Icons/Icons";
import { TbRepeatOnce } from "react-icons/tb";
import styled from "styled-components";
import { IMAGE_SRC } from "../../../common/constants";
export interface ControlState {}

export default function Control(props: ControlState) {
  const [loadingPlay, setLoadingPlay] = React.useState(false);
  const dispatch = useDispatch();
  const playlist = useSelector((state: RootState) => state.audio.playlist);
  const isRepeat = useSelector((state: RootState) => state.audio.isRepeat);
  const isPlay = useSelector((state: RootState) => state.audio.isPlay);
  let currentIndexSong = useSelector(
    (state: RootState) => state.audio.currentIndexSong
  );
  let volumeValue = useSelector((state: RootState) => state.audio.volumeValue);
  let songActive = document.querySelector<HTMLDivElement>(".song-item.active");
  const audioRef = React.useRef<HTMLAudioElement>(null);
  const handlePlaySong = () => {
    if (isPlay) {
      dispatch(setPlay(false));
      audioRef.current?.pause();
    } else {
      dispatch(setPlay(true));
      audioRef.current?.play();
    }
  };

  const handleNextSong = () => {
    setLoadingPlay(true);

    if (currentIndexSong >= playlist?.songs.length - 1) {
      dispatch(setCurrentIndexSong(0));
    } else {
      dispatch(setCurrentIndexSong((currentIndexSong += 1)));
    }
    dispatch(setPlay(true));
  };
  const handlePrevSong = () => {
    setLoadingPlay(true);

    if (currentIndexSong <= 0) {
      dispatch(setCurrentIndexSong(playlist?.songs.length - 1));
    } else {
      dispatch(setCurrentIndexSong((currentIndexSong -= 1)));
    }
    dispatch(setPlay(true));
  };

  const handleOntimeUpdate = () => {
    if (audioRef.current?.duration) {
      setLoadingPlay(false);
    }
  };

  React.useEffect(() => {
    if (audioRef.current && audioRef.current.volume) {
      audioRef.current.volume = (volumeValue as number) / 100;
    }
  }, [volumeValue]);

  const isDisabled = React.useMemo(() => {
    return loadingPlay;
  }, [loadingPlay]);
  const disabledBtn = React.useMemo(() => {
    return {
      opacity: isDisabled ? 0.5 : 1,
      cursor: isDisabled ? "not-allowed" : "pointer",
    };
  }, [isDisabled]);
  React.useEffect(() => {
    if (isPlay) {
      audioRef.current?.play();
    } else {
      audioRef.current?.pause();
    }
  }, []);
  React.useEffect(() => {
    if (songActive) {
      scrollIntoView(songActive, "center");
    }
  }, [songActive]);
  return (
    <StyledControl>
      <div className="px-3 py-2 rounded-md flex items-center gap-x-4 bg-alphaBg">
        <button
          disabled={isDisabled}
          style={disabledBtn}
          onClick={handlePrevSong}
          className="relative select-none cursor-pointer"
        >
          <img className="cursor-pointer" src={Icons.prev} alt="" />
        </button>
        <div
          onClick={handlePlaySong}
          className="relative w-3 flex-shrink-0 cursor-pointer"
        >
          {isPlay && !loadingPlay ? (
            <img className="cursor-pointer" src={Icons.pause} alt="" />
          ) : (
            !loadingPlay && (
              <img className="cursor-pointer" src={Icons.play} alt="" />
            )
          )}
          {loadingPlay && <img src={IMAGE_SRC.loading} alt="" />}
        </div>
        <button
          disabled={isDisabled}
          style={disabledBtn}
          onClick={handleNextSong}
          className="relative select-none cursor-pointer"
        >
          <img className="cursor-pointer" src={Icons.next} alt="" />
        </button>
        <div
          onClick={() => dispatch(setRepeat(!isRepeat))}
          className="relative cursor-pointer"
        >
          <TbRepeatOnce
            className={`text-xl repeat-icon text-white ${
              isRepeat ? "is-repeat" : ""
            }`}
          />
        </div>
      </div>
      <audio
        id="myAudio"
        loop={isRepeat}
        autoPlay
        src={playlist?.songs[currentIndexSong]?.source}
        ref={audioRef}
        onEnded={handleNextSong}
        onTimeUpdate={handleOntimeUpdate}
      ></audio>
    </StyledControl>
  );
}
const StyledControl = styled.div`
  .repeat-icon.is-repeat {
    color: #f3a952;
  }
`;
